<desy-listbox
  [isMultiselectable]="isMultiselectable"
  [classes]="(classes || 'min-w-fit w-auto') + (isInvalid() ? ' border-red-500' : '')"
  (activeItemChange)="onSelect()"
  [html]="html + ' ' + '(' + selectedItems().length + ')'">
  <ng-container *ngFor="let item of options">
    <desy-listbox-item
      [id]="item.value"
      [title]="item.label"
      [(active)]="item.check"
      classes="min-w-80">
      {{ item.label }}
    </desy-listbox-item>
  </ng-container>
</desy-listbox>
<div
  *ngIf="isInvalid() && touched()"
  class="text-alert-base mt-1">
  Debes seleccionar al menos un elemento
</div>
